import { render, staticRenderFns } from "./InvL_Search.vue?vue&type=template&id=56716a4e"
import script from "./InvL_Search.vue?vue&type=script&lang=js"
export * from "./InvL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports